module.exports = __webpack_public_path__ + "static/media/iceland-flag.fa933e25.png";